// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__DqzWr","paramInput":"JobSimulator_paramInput__2uJgF","input":"JobSimulator_input__33MYS"};